<h1 mat-dialog-title>{{ dialogTitle }}</h1>

<mat-dialog-content class="mat-typography dialog-content">
  <div [nbSpinner]="isFetchingActGroupMessage">
    <!-- FORM -->
    <form [formGroup]="actGroupMessageFrm" class="form-container">

      <mat-form-field appearance="outline" *ngIf="isEditMode" class="full-width">
        <mat-label>ID</mat-label>
        <input matInput formControlName="id" readonly>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width large-field">
        <mat-label>Message</mat-label>
        <textarea matInput formControlName="message" rows="10" class="large-text"></textarea>
        <mat-error *ngIf="actGroupMessageFrm.get('message')?.hasError('required')">
          Message is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width large-field">
        <mat-label>Message Type</mat-label>
        <mat-select formControlName="type" class="large-text">
          <mat-option *ngFor="let type of messageTypes" [value]="type.value" class="large-option">
            {{ type.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="action === actionType.Edit">
        <div class="checkbox-group">
          <mat-checkbox formControlName="active" color="primary">
            Active
          </mat-checkbox>
        </div>
      </ng-container>

      <div class="checkbox-group">
        <mat-checkbox formControlName="isBlockCommunicate" color="primary">
          Block Communication
        </mat-checkbox>
      </div>
    </form>
  </div>

  <!-- PROFILE RELATIONSHIP SECTION -->
  <div class="profile-relationship-wrapper" [nbSpinner]="isLoadingProfile">
    <div class="profile-header">
      <p class="h6">Profile Relationships</p>
      <mat-checkbox *ngIf="profileList?.length" [checked]="isAllProfilesSelected()"
        [indeterminate]="isSomeProfilesSelected()" (change)="onSelectAllProfiles($event)" color="primary">
        Select All
      </mat-checkbox>
    </div>

    <div *ngIf="profileList?.length" class="profile-grid">
      <div *ngFor="let p of profileList" class="profile-container">
        <app-act-group-profile-info [profile]="p"
          (onCheckProfileId)="onAddProfileIdToGroupMessage($event)"></app-act-group-profile-info>
      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" type="button" [disabled]="isSavingActGroupMessage">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="onSave()"
    [disabled]="actGroupMessageFrm.invalid || isSavingActGroupMessage || isLoadingProfile" type="button"
    [nbSpinner]="isSavingActGroupMessage">
    {{ isEditMode ? 'Update' : 'Save' }}
  </button>
</mat-dialog-actions>